/**
 * OOO Sleep LP — interactive logic
 * Handles: variant toggle, plan (delivery) toggle, gallery thumbs, FAQ accordion.
 * Reveal / motion are handled globally by ooo-motion.js.
 * Cart is handled globally by ooo-cart.js.
 */
(function () {
  'use strict';

  /* ── helpers ─────────────────────────────────────────────── */
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ── Variant toggle (V1 / V4) ───────────────────────────── */
  function initVToggles() {
    $$('.ooo-sleep-vtoggle').forEach(function (group) {
      $$('.ooo-sleep-vtoggle__opt', group).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('.ooo-sleep-vtoggle__opt', group).forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          // update hidden variant id on closest add-to-cart form
          var v = btn.dataset.v;
          var form = group.closest('.ooo-lp-sleep-hero__offer, .ooo-lp-sleep-buy__plans');
          if (!form) return;
          var varInput = form.querySelector('[name="id"]');
          if (!varInput) return;
          var map = {};
          try { map = JSON.parse(varInput.dataset.variantMap || '{}'); } catch (e) { /* noop */ }
          // Determine active plan (sub vs one-time)
          var activePlan = form.querySelector('.ooo-sleep-opt.is-active');
          var planKey = (activePlan && activePlan.dataset.plan === 'one') ? 'one' : 'sub';
          var key = v + '_' + planKey; // e.g. v1_sub, v4_one
          if (map[key]) varInput.value = map[key];
        });
      });
    });
  }

  /* ── Plan / delivery toggle (subscribe vs one-time) ────── */
  function initPlanToggles() {
    $$('.ooo-lp-sleep-hero__offer, .ooo-lp-sleep-buy__plans').forEach(function (scope) {
      $$('.ooo-sleep-opt', scope).forEach(function (opt) {
        opt.addEventListener('click', function () {
          $$('.ooo-sleep-opt', scope).forEach(function (o) { o.classList.remove('is-active'); });
          opt.classList.add('is-active');
          // Re-sync variant id when plan changes
          var varInput = scope.closest('form') && scope.closest('form').querySelector('[name="id"]')
                         || scope.querySelector('[name="id"]');
          if (!varInput) return;
          var map = {};
          try { map = JSON.parse(varInput.dataset.variantMap || '{}'); } catch (e) { /* noop */ }
          var activeV = scope.querySelector('.ooo-sleep-vtoggle__opt.is-active');
          var vKey = (activeV && activeV.dataset.v) || 'v1';
          var planKey = opt.dataset.plan === 'one' ? 'one' : 'sub';
          var key = vKey + '_' + planKey;
          if (map[key]) varInput.value = map[key];
        });
      });
    });
  }

  /* ── Gallery thumbnail switcher ────────────────────────── */
  function initGallery() {
    $$('.ooo-lp-sleep-hero__gallery').forEach(function (gallery) {
      var mainImg  = gallery.querySelector('.ooo-lp-sleep-hero__main img');
      var thumbs   = $$('.ooo-lp-sleep-hero__thumbs img', gallery);
      if (!mainImg || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          mainImg.src    = thumb.src;
          mainImg.srcset = thumb.srcset || '';
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ── FAQ accordion (native <details>) ──────────────────── */
  /* The FAQ uses native <details> — no JS needed for open/close.
     We add exclusive-open behaviour (close others on open). */
  function initFaq() {
    var items = $$('.ooo-lp-sleep-faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  }

  /* ── Boot ───────────────────────────────────────────────── */
  function boot() {
    initVToggles();
    initPlanToggles();
    initGallery();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
